/* @ngInject */
const displayRun = (
  $transitions,
  routes
) => {

}

export default displayRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/display/display.run.js